<template>
    <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(1 1)" stroke="#033D89" fill="none" fill-rule="evenodd">
            <circle stroke-width="1.5" cx="14" cy="14" r="14"/>
            <path stroke-width="2" stroke-linecap="round" d="m18.5 13.5-4.517 4-4.483-4"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconArrow',
};
</script>
